import { Breakpoints } from '../_constants/breakpoints';
export const screen = {
    xsmallOnly: `(max-width: ${Breakpoints.Small - 1}px)`,
    smallUp: `(min-width: ${Breakpoints.Small}px)`,
    mediumUp: `(min-width: ${Breakpoints.Medium}px)`,
    largeUp: `(min-width: ${Breakpoints.Large}px)`,
};
